// eslint-disable-next-line import/prefer-default-export
export enum EnablementFeatureFlags {
  /**
   * If true, the connectivity tester will be accessible.
   */
  ConnectivityTesterEnabled = 'show_connectivity_tester',
  /**
   * If true, user will be able to see 'Subscribe to access' buttons throughout the app.
   */
  ShowSubscriptionToUnlockEnabled = 'show_subscription_to_unlock_button',
  /**
   * If true, the 'schedule' and 'schedule all' buttons for premium sessions will be DISABLED (read only).
   */
  ShowPremvtScheduleDisabled = 'show_premvt_schedule_disabled',
  /**
   * If true, the "Exam readiness checklist" will be displayed.
   */
  ShowExamChecklistComplete = 'show_exam_checklist_complete',
  /**
   * If true, "How to buy" and "compare plans" UI elements will be displayed.
   */
  ShowHowToBuy = 'show_how_to_buy',
  /**
   * If true, "What's next" suggestions will be displayed for courses.
   */
  ShowWhatsNext = 'whats_next',
  /**
   * If true, user will be able to access bookshelf if other conditions are met.
   */
  BookshelfEnabled = 'bookshelf_enabled',
  /**
   * If true, the new RHLS 5.0 home page will be displayed instead of the legacy one.
   */
  NewHomePage = 'new_home_page',
  /**
   * If true, the user will be able to see the "Live events" list in the RHLS 5.0 home page.
   */
  NewHomePageCanViewUpcomingEvents = 'new_home_page_can_view_upcoming_events',
  /**
   * If true, the "Live sessions tab" will appear in the course overview page (course landing page).
   */
  CourseLiveSessionsTab = 'course_live_sessions_tab',
  /**
   * If true, the catalog will be accessible (4.0 or 5.0). If false, the user will not be able to see the catalog.
   */
  CanViewCatalog = 'can_view_catalog',
  /**
   * If true, the new RHLS 5.0 catalog will be displayed (new cards)
   */
  NewCatalog = 'new_catalog',
  /**
   * If true, the catalog source will be based on the policy and fixed catalog APIs.
   */
  PolicyBasedCatalog = 'policy_based_catalog',
  /**
   * If true, the new rhls 5.0 cards will display the save-for-later pin when available.
   * Wire key stays favorite_cards_enabled for deployed config compatibility.
   */
  SavedForLaterCardsEnabled = 'favorite_cards_enabled',
  /**
   * If true, the "New" offerings lane is shown on My Training.
   */
  NewOfferingsLaneEnabled = 'new_offerings_lane_enabled',
  /**
   * If true, the "Live sessions catalog" will display a list with the new RHLS 5 cards instead of the legacy list.
   */
  NewPremiumCatalog = 'new_premium_catalog',
  /**
   * If true, the live classes feature is enabled.
   */
  LiveClassEnabled = 'live_class_enabled',
  /**
   * If true, the new enrollments download URL will be used.
   */
  ClassDashboardEnrollmentsDownloadV2 = 'class_dashboard_enrollments_download_v2',
  /**
   * If true, user will be able to access AI Assistant.
   */
  AIAssistantEnabled = 'ai_assistant_enabled',

  /**
   * If true, user will be able to access Elaborate within AI Assistant.
   */
  AIAssistantElaborateEnabled = 'ai_assistant_elaborate_enabled',

  /**
   * If true, the lab version dropdown will be displayed in the lab environment panel.
   */
  ClassLabVersionsDropdown = 'class_lab_versions_dropdown',

  /**
   * If true, the user can see Skills Paths (header nav, search tab, learning path widget).
   */
  SkillsPathsEnabled = 'skills_paths_enabled',

  /**
   * If true, the authenticated user can see the User Dashboard menu item in the header and access the User Dashboard page.
   */
  UserDashboardEnabled = 'user_dashboard_enabled',
  /**
   * If true, the user can see the Discover and Plan section in the My Activity page. (If user has no enrollment, then the section will not be displayed.)
   */
  ShowDiscoverAndPlanSection = 'new_home_page_discover_and_plan_section',
  /**
   * If true, the user can see the Reports page and header navigation.
   */
  CanViewReports = 'can_view_reports',
  /**
   * If true, instructor dashboard class list shows date/time and other advanced filters.
   */
  InstructorClassListAdvancedFiltersEnabled = 'instructor_class_list_advanced_filters_enabled',

  /**
   * If true, instructors can access the Instructor Dashboard V2 route (/instructor-dashboard).
   */
  InstructorDashboardEnabled = 'instructor_dashboard_enabled',
  /**
   * If true, the legacy Instructor Dashboard link (classes:list) is shown in the account menu.
   */
  OldInstructorDashboardEnabled = 'old_instructor_dashboard_enabled',
  /**
   * If true, the new My Training page will be displayed instead of the legacy one.
   */
  NewMyTraining = 'new_my_training',
  /**
   * If true, the profile page shows an advanced settings section with
   * troubleshooting tools such as clearing the service worker cache.
   */
  AdvancedSettingsEnabled = 'advanced_settings_enabled',
  /**
   * If true, the new My Training navigation will be displayed instead of the legacy one.
   */
  NewMyTrainingNavigation = 'new_my_training_navigation',
  /**
   * If true, the User Dashboard progress table uses RHLS 5.0 offering cards in a grid layout.
   * If false, the legacy vertical 4.0 cards are shown (production fallback).
   */
  NewUserDashboard = 'is_new_user_dashboard_enabled',
  /**
   * If true, the new RHLS 5.0 search page will be displayed instead of the legacy one.
   */
  NewSearch = 'new_search',
  /**
   * If true, Search V2 uses the Luna AI search endpoint instead of Elasticsearch.
   */
  NewSearchAiBasedEnabled = 'new_search_ai_based_enabled',
  /**
   * If true (default), Search V2 may show the Luna AI overview and its sidebar toggle
   * when AI-based search is enabled. If false, overview UI and toggle are hidden.
   */
  NewSearchAiOverviewEnabled = 'new_search_ai_overview_enabled',
  /**
   * If true, the lab notification will be displayed throughout the app.
   */
  LabNotificationEnabled = 'lab_notification_enabled',
}
